import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import NotificationPanel from '@helsenorge/designsystem-react/components/NotificationPanel';
import Spacer from '@helsenorge/designsystem-react/components/Spacer';
import styles from './styles.module.scss';
const ErrorMessage = ({ label, labelId, description, correlationId }) => {
    return (_jsxs(NotificationPanel, { role: "alert", variant: 'error', label: label, labelId: labelId, children: [description && _jsx("p", { children: description }), correlationId && (_jsxs(_Fragment, { children: [_jsx(Spacer, { size: "s" }), _jsx("p", { className: styles.errormessage__correlationid, children: `Id: ${correlationId}` })] }))] }));
};
export default ErrorMessage;
